<template>
  <div class="base-info">
    <a-form :form="form">
      <a-card :bordered="false" title="版本信息" :headStyle="{paddingLeft:'0px'}" v-if="info">
        <a-form-item label="当前版本" v-bind="baseItemLayout">
          {{ info.informationName }}
          <!--          <a>版本权益</a>-->
        </a-form-item>
        <a-form-item label="到期时间" v-bind="baseItemLayout">
          {{ info.versionMerchantExpiredDate }}到期，续费后有效期将顺延
        </a-form-item>
        <div v-if="info && info.informationId > 2">
          <a-form-item label="" v-bind="baseItemLayout">
            <div class="tabMian">
              <div class="tabLeft" :class="{'tabstyle':isActive==2}" @click="chooseYear(2)">
                <p>续费两年</p>
                <p>￥<i>{{ info.informationAmount * 2 }}</i></p>
              </div>
              <div class="tabLeft" :class="{'tabstyle':isActive==1}" @click="chooseYear(1)">
                <p>续费一年</p>
                <p>￥<i>{{ info.informationAmount }}</i></p>
              </div>
            </div>
          </a-form-item>
          <a-form-item label="支付方式" v-bind="baseItemLayout">
            <a-radio-group name="radioGroup" v-model="params.type" @change="radioChange">
              <a-radio :value="1">
                支付宝
              </a-radio>
              <a-radio :value="2">
                微信
              </a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item label=" " v-bind="baseItemLayout" :colon="false" :required="false">
            <div class="bankInfoText2">
              <p>请{{ params.type == 1 ? '支付宝' : '微信' }}扫描下方二维码完成支付</p>
              <img :src="erWeiMaImageSrc"/>
            </div>
          </a-form-item>
        </div>
      </a-card>
    </a-form>
  </div>
</template>

<script>
import formMixins from '../../../utils/mixins/formMixins'
import moment from 'moment'

export default {
  name: 'VersionInfo',
  mixins: [formMixins],
  props: {
    tabKey: {
      type: Number | String,
      default: 1
    }
  },
  data() {
    return {
      businessFileList: [],
      info: '',
      isActive: 2,
      money: '',
      params: {
        type: 1
      },
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      erWeiMaImageSrc: '',
      randomNumber: ''
    }
  },
  watch: {
    tabKey(key) {
      if (key != 1) {
        this.clearTimeout()
      } else {
        this.getQueryDetails()
      }
    }
  },
  destroyed() {
    this.clearTimeout()
  },
  mounted() {
    this.getQueryDetails()
  },
  methods: {
    chooseYear(num) {
      this.isActive = num
      this.money = this.info.informationAmount * num
      this.getCodeImg()
    },
    radioChange(value) {
      this.params.type = value.target.value
      this.getCodeImg()
    },
    getQueryDetails() {
      this.getHttpServices().getUserService().post('api/v2/versionInformation/queryDetails')
        .then(res => {
          if (res) {
            this.info = res
            this.money = this.info.informationAmount * this.isActive
            this.getRandomNumber()
          }
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //GET /service/rechargeCodeImg/{type}/{merchantId}/{informationId}/{totalFee}/{years}
    getCodeImg() {
      const url = `service/rechargeVersionCodeImg/${this.params.type}/${this.merchantId}/${this.platformId}/${this.info.informationId}/${this.money}/${this.isActive}/${this.randomNumber}`
      this.erWeiMaImageSrc = this.getAppConfig().serviceUrl + url
    },
    // 获取 生成随机数接口
    getRandomNumber() {
      this.getHttpServices().getServerApiService().get('service/generateRandomNumber/' + this.merchantId + '/' + this.platformId).then(res => {
        this.getLogUtils().logWithTag('res-----data', res)
        if (res && res.randomNumber) {
          this.randomNumber = res.randomNumber
          this.getCodeImg()
          this.getTimer()
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    updatePayStatus() {
      const params = {
        merchantId: this.merchantId,
        platformId: this.platformId,
        randomNumber: this.randomNumber
      }
      this.getHttpServices().getServerApiService().post('service/versionPayUpgradeStatus', params).then(res => {
        this.getLogUtils().logWithTag('res-----data', res)
        if (res && res.payStatus) {
          this.clearTimeout()
          this.getRandomNumber()
          this.$message.success('支付成功')
        }
      }).catch(reason => {
        this.getLogUtils().logWithTag('reason', reason)
      })
    },
    getTimer() {
      this.timer = setInterval(this.updatePayStatus, 1000)
    },
    clearTimeout() {
      clearInterval(this.timer)
      this.timer = null
    }
  }
}
</script>
<style lang="less" scoped>
@import "./baseInfo";

.tabMian {
  .tabLeft {
    width: 200px;
    padding: 20px;
    position: relative;
    margin-left: 30px;
    border: 1px #eee solid;
    text-align: center;
    display: inline-block;
    cursor: pointer;

    p {
      font-size: 16px;
      margin-bottom: 0;
    }

    p:nth-child(2) {
      font-size: 14px;
      color: red;

      i {
        font-style: normal;
        font-size: 26px;
      }
    }

    p:nth-child(4) {
      font-size: 12px;
      line-height: 24px;
      background-color: #FEA834;
      color: #fff;
    }
  }

  .tabLeft.tabstyle {
    background-color: #ffeddf;
    border: 1px #ff7700 solid;
  }
}

.bankInfoText {
  p {
    line-height: 26px;
    margin-bottom: 0;
  }

  p:nth-child(1) {
    color: #000;
  }
}

.bankInfoText2 {
  p {
    margin-bottom: 0;
  }

  img {
    width: 200px;
    height: 200px;
  }
}
</style>